import { Typography, Box, Paper } from '@mui/material';
import { MessageItem } from './types';

interface MessageDescriptionProps {
    dataItem: MessageItem;
}

export function MessageDescription({ dataItem }: MessageDescriptionProps) {
    return (
        <Box sx={{ mb: 2 }}>
            <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase' }}>
                Description
            </Typography>
            <Paper variant="outlined" sx={{ p: 2, bgcolor: '#f5f5f5', mt: 0.5 }}>
                <Typography variant="body2"sx={{ whiteSpace: 'pre-wrap', fontSize: '0.85rem' }}>{dataItem.description}</Typography>
            </Paper>
        </Box>
    );
}